import type { ComponentProps } from 'react';

import googlePlayLogo from './googlePlayLogo.png';

export const GooglePlayLogo = (props: ComponentProps<'img'>) => {
  // biome-ignore lint/a11y/useAltText: alt is provided, is this a bug ?
  return <img height={38.22} width={129} src={googlePlayLogo} alt="Google Play logo" {...props} />;
};
